export default __webpack_public_path__ + "static/media/sponsor-5.34f0ea73.svg";